export default "__VITE_ASSET__De9vFPZa__"